import {Component, Input, OnInit} from '@angular/core';
import {Config, FieldDefine, FieldType, LanguagesService} from '../../../../core';
import {GridFormComponent} from '../grid-form.component';

@Component({
  selector: 'gc-filter-item-value',
  templateUrl: './filter-item-value.component.html',
  styleUrls: ['./filter-item-value.component.css']
})
export class FilterItemValueComponent implements OnInit {
  FieldTypeEnum = FieldType;
  dateFormat = Config.dateFormat;

  constructor(private lang: LanguagesService) { }

  public boolValueListItems: Array<{ text: string, value: number }> = [
    { text: '', value: null },
    { text: this.lang.define.lib.yes, value: 1 },
    { text: this.lang.define.lib.no, value: 0 }
  ];

  @Input() public field: FieldDefine;
  @Input() public form: GridFormComponent;

  ngOnInit(): void {
  }

}
